module.exports = __webpack_public_path__ + "media/src/images/icon__magazinFalsch2--dark-fb9e179c1f35a44f8213168915f625d8.svg";